// extracted by mini-css-extract-plugin
export default {"wrapper":"trialBar_wrapper__Z2llO"};